import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '@/components/ui/dialog'
import { CarcassFinishFields } from '@/components/features/finishes/CarcassFinishFields'

interface CarcassFinishSectionProps {
  // General finish from project defaults
  generalFinish?: {
    finish: string
    carcassColor: string
    edgeColor?: string
    edgeColorSameAsDoor: boolean
    sideViewFinish?: string
    sideViewFinishSameAsDoor: boolean
  }
  
  // Current values
  useGeneral: boolean
  customFinish?: string
  customColor?: string
  customEdgeColor?: string
  customEdgeColorSameAsDoor?: boolean
  customSideViewFinish?: string
  customSideViewFinishSameAsDoor?: boolean
  
  // Callbacks
  onUseGeneralChange: (useGeneral: boolean) => void
  onCustomFinishChange: (finish: string) => void
  onCustomColorChange: (color: string) => void
  onCustomEdgeColorChange: (color: string) => void
  onCustomEdgeColorSameChange: (same: boolean) => void
  onCustomSideViewFinishChange: (finish: string) => void
  onCustomSideViewFinishSameChange: (same: boolean) => void
  
  // Options for combobox
  materialOptions?: string[]

  // Dialog control (headless mode)
  open: boolean
  onOpenChange: (open: boolean) => void
}

export function CarcassFinishSection({
  generalFinish: _generalFinish,
  useGeneral,
  customFinish = '',
  customColor = '',
  customEdgeColor = '',
  customEdgeColorSameAsDoor = true,
  customSideViewFinish = '',
  customSideViewFinishSameAsDoor = true,
  onUseGeneralChange,
  onCustomFinishChange,
  onCustomColorChange,
  onCustomEdgeColorChange,
  onCustomEdgeColorSameChange,
  onCustomSideViewFinishChange,
  onCustomSideViewFinishSameChange,
  materialOptions,
  open,
  onOpenChange,
}: CarcassFinishSectionProps) {
  return (
      <Dialog open={open} onOpenChange={onOpenChange}>
        <DialogContent className="sm:max-w-[500px]">
          <DialogHeader>
            <DialogTitle>Finition de la caisse</DialogTitle>
          </DialogHeader>

          <div className="py-4 space-y-4">
            <div className="space-y-2">
              <div className="flex gap-4 text-sm">
                <label className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="radio"
                    checked={useGeneral}
                    onChange={() => onUseGeneralChange(true)}
                    className="w-4 h-4"
                  />
                  <span>Finition de base</span>
                </label>
                <label className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="radio"
                    checked={!useGeneral}
                    onChange={() => onUseGeneralChange(false)}
                    className="w-4 h-4"
                  />
                  <span>Spécifique à ce meuble</span>
                </label>
              </div>              
            </div>

            {!useGeneral && (
              <div className="space-y-3">
                <p className="text-xs text-muted-foreground">
                  Définissez ici la finition personnalisée  pour ce module.
                </p>
                <CarcassFinishFields
                  finish={customFinish}
                  color={customColor}
                  edgeColor={customEdgeColor}
                  edgeColorSameAsDoor={customEdgeColorSameAsDoor}
                  sideViewFinish={customSideViewFinish}
                  sideViewFinishSameAsDoor={customSideViewFinishSameAsDoor}
                  onFinishChange={onCustomFinishChange}
                  onColorChange={onCustomColorChange}
                  onEdgeColorChange={onCustomEdgeColorChange}
                  onEdgeColorSameChange={onCustomEdgeColorSameChange}
                  onSideViewFinishChange={onCustomSideViewFinishChange}
                  onSideViewFinishSameChange={onCustomSideViewFinishSameChange}
                  materialOptions={materialOptions}
                />
              </div>
            )}
          </div>

          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>
              Annuler
            </Button>
            <Button
              type="button"
              onClick={() => onOpenChange(false)}
              disabled={!useGeneral && (!customFinish || !customColor)}
            >
              Appliquer
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
  )
}
